import {
  AddGuestToTripRoomInput,
  CreateTripRoomInput,
  DeleteTripRoomInput,
  EditTripRoomGuestInput,
  GetTripRoomInput,
  GetTripRoomOutput,
  MoveGuestToTripRoomInput,
  RemoveGuestFromTripRoomInput,
} from "@cruisen/contract"
import { callFirebaseFunction } from "../callFirebaseFunction"

export const createTripRoom = async (payload: CreateTripRoomInput) => {
  const response = await callFirebaseFunction({
    name: "tripRoomAction",
    payload: {
      action: "createTripRoom",
      ...payload,
    },
  })
  if (response.error) {
    console.log(response.error)
    return undefined
  }
  return response.data
}

export const addGuestToTripRoom = async (payload: AddGuestToTripRoomInput) => {
  const response = await callFirebaseFunction({
    name: "tripRoomAction",
    payload: {
      action: "addGuestToTripRoom",
      ...payload,
    },
  })
  if (response.error) {
    throw new Error("Failed to add guest to trip room")
  }
  return response.data
}

export const editTripRoomGuest = async (payload: EditTripRoomGuestInput) => {
  const response = await callFirebaseFunction({
    name: "tripRoomAction",
    payload: {
      action: "editTripRoomGuest",
      ...payload,
    },
  })
  if (response.error) {
    throw new Error("Failed to edit trip room guest")
  }
  return response.data
}

export const moveGuestToTripRoom = async (payload: MoveGuestToTripRoomInput) => {
  const response = await callFirebaseFunction({
    name: "tripRoomAction",
    payload: {
      action: "moveGuestToTripRoom",
      ...payload,
    },
  })
  if (response.error) {
    throw new Error("Failed to move guest to trip room")
  }
  return response.data
}

export const deleteTripRoom = async (payload: DeleteTripRoomInput) => {
  const response = await callFirebaseFunction({
    name: "tripRoomAction",
    payload: {
      action: "deleteTripRoom",
      ...payload,
    },
  })
  if (response.error) {
    console.log(response.error)
    return undefined
  }
  return response.data
}

export const removeGuestFromTripRoom = async (payload: RemoveGuestFromTripRoomInput) => {
  const response = await callFirebaseFunction({
    name: "tripRoomAction",
    payload: {
      action: "removeGuestFromTripRoom",
      ...payload,
    },
  })
  if (response.error) {
    throw new Error("Failed to remove guest from trip room")
  }
  return response.data
}

export const getTripRoom = async (payload: GetTripRoomInput) => {
  try {
    const response = await callFirebaseFunction({
      name: "tripRoomAction",
      payload: {
        action: "getTripRoom",
        ...payload,
      },
    })

    return (response.data as unknown as GetTripRoomOutput)?.result
  } catch (error) {
    console.error("Failed to get trip room", error)
    return undefined
  }
}
